import useCrmObjectTypeProperties from 'framework-listing-lib/internal/hooks/useCrmObjectTypeProperties';
export default function useProperty(propertyName) {
  const {
    dataAsJS: propertyMap
  } = useCrmObjectTypeProperties();
  return propertyMap[propertyName];
}